import { InjectionToken } from '@angular/core';

export interface FavoriteConfig {
  apiUrl: string;
}

export const FAVORITE_CONFIG = new InjectionToken<FavoriteConfig>('FavoriteConfig');
